module.exports = __webpack_public_path__ + "static/media/tta_banner_v1.0532d465.jpg";